__turbopack_context__.v({
  "numberFormatInput": "CalculatorInput-module-scss-module__c3-A7a__numberFormatInput",
});
